import BaseClass from "../BaseClass.js";

export default class FilterHighlighter extends BaseClass {

    constructor(element) {
        super(element);

        this.highlightClass = null;
        this.filterElementsListener = null;
        this.filterElements = [];
        this.closeElements = [];
        this.stopPropagationElementsListener = null;
        this.stopPropagationElements = [];

        this.init();
    }

    init() {
        let mySelf = this;

        const highlightClass = this.$element.data('highlight-class');
        if (highlightClass != undefined) {
            this.highlightClass = highlightClass;
        }

        const filterElements = this.$element.find('[data-highlight-filter]');
        if (filterElements.length > 0) {
            this.filterElements = filterElements;
            this.filterElementsListener = function () {
                mySelf.appearanceChange();
            }
            this.filterElements.on('click', this.filterElementsListener);
        }

        const closeElements = this.$element.find('[data-close-class]');
        if (closeElements.length > 0) {
            this.closeElements = closeElements;
        }

        const stopPropagationElements = this.$element.find('[data-type="stop-propagation"]');
        if (stopPropagationElements.length > 0) {
            this.stopPropagationElements = stopPropagationElements;
            this.stopPropagationElementsListener = function (event) {
                mySelf.stopPropagationElementsEvent(event);
            }
            this.stopPropagationElements.on('click', this.stopPropagationElementsListener);
        }
    }

    appearanceChange() {
        if (this.highlightClass) {
            let highlight = false;

            for (let i = 0; i < this.filterElements.length; i++) {
                let element = $(this.filterElements[i]);

                if ('radio' == element.attr('type') && element.is(':checked') && element.data('highlight-filter')) {
                    highlight = true;
                }

                if ('checkbox' == element.attr('type') && element.is(':checked') && element.data('highlight-filter')) {
                    highlight = true;
                }
            }

            this.$element.removeClass(this.highlightClass);

            if (highlight) {
                this.$element.addClass(this.highlightClass);
            }
        }

        if (this.closeElements.length > 0) {
            this.closeElements.each(
                function () {
                    let element = $(this);
                    let closeClass = element.data('close-class');
                    element.removeClass(closeClass);
                }
            );
        }
    }

    stopPropagationElementsEvent(event) {
        event.stopPropagation();
    }

    destroyListener() {
        if (this.filterElements.length > 0) {
            this.filterElements.off('click', this.filterElementsListener);
        }
    }
}